import { type Dispatch, type SetStateAction, useState } from "react";

import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type {
  IntegrationCrmType,
  LeadsSearchParams,
  SelectedFacetParam,
} from "common/types";

import ExportOptions from "./ExportOptions";
import ListAndCampaignSelect from "./ListAndCampaignSelect";

import type { OUTREACH_CRM_EXPORT_OPTIONS } from "../../../../constants";

type Option = keyof typeof OUTREACH_CRM_EXPORT_OPTIONS;

interface OutreachExportModalProps {
  type: IntegrationCrmType;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  searchParams: LeadsSearchParams<SelectedFacetParam>;
}

export default function OutreachExportModal({
  type,
  isOpen,
  setIsOpen,
  searchParams,
}: OutreachExportModalProps) {
  const defaultOption: Option = "campaign";
  const defaultStepIndex = type === "instantly" ? 0 : 1;

  const [stepIndex, setStepIndex] = useState(defaultStepIndex);
  const [selectedOption, setSelectedOption] = useState<Option>(defaultOption);
  const isDesktop = useTwBreakpoint("lg");

  function onReset() {
    setStepIndex(defaultStepIndex);
    setSelectedOption(defaultOption);
  }

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen} onAfterClose={onReset}>
      <Content className="lg:w-[448px]">
        {stepIndex === 0 ? (
          <ExportOptions
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            onNext={() => setStepIndex(1)}
          />
        ) : (
          <ListAndCampaignSelect
            crmType={type}
            type={selectedOption}
            onBack={() => setStepIndex(0)}
            searchParams={searchParams}
          />
        )}
      </Content>
    </Component>
  );
}
